import { gql } from '@provision/graphql-client';
import { RECORD_FOLDER_ASSIGNMENT_FRAGMENT } from './record-folder-assignment.fragments';

export const GET_RECORD_FOLDER_ASSIGNMENT_QUERY = gql`
  query GetRecordFolderAssignment($params: QueryParams)
  @entity(name: "RecordFolderAssignment") {
    getRecordFolderAssignment(queryParams: $params) {
      records {
        ...RecordFolderAssignmentFields
      }
    }
  }
  ${RECORD_FOLDER_ASSIGNMENT_FRAGMENT}
`;

export const CREATE_RECORD_FOLDER_ASSIGNMENT_QUERY = gql`
  mutation CreateRecordFolderAssignment($data: RecordFolderAssignmentDataInput) {
    createRecordFolderAssignment(data: $data) {
      ...RecordFolderAssignmentFields
    }
  }
  ${RECORD_FOLDER_ASSIGNMENT_FRAGMENT}
`;

export const UPDATE_RECORD_FOLDER_ASSIGNMENT_QUERY = gql`
  mutation UpdateRecordFolderAssignment(
    $recordFolderAssignmentId: String!
    $data: RecordFolderAssignmentDataInput
  ) {
    updateRecordFolderAssignment(
      conditions: [
        {
          attribute: "recordFolderAssignmentId"
          operator: "="
          value: $recordFolderAssignmentId
        }
      ]
      data: $data
    ) {
      ...RecordFolderAssignmentFields
    }
  }
  ${RECORD_FOLDER_ASSIGNMENT_FRAGMENT}
`;

export const DELETE_RECORD_FOLDER_ASSIGNMENT_QUERY = gql`
  mutation DeleteRecordFolderAssignment($recordFolderAssignmentId: String!) {
    deleteRecordFolderAssignment(
      conditions: [
        {
          attribute: "recordFolderAssignmentId"
          operator: "="
          value: $recordFolderAssignmentId
        }
      ]
    ) {
      id
    }
  }
`;
